const hi = {
    "gui.menuBar.file": "फ़ाइल",
    "gui.menuBar.edit": "संपादित करें",
    "gui.menuBar.new": "नया",
    "gui.menuBar.saveNow": "अभी सहेजें",
    "gui.menuBar.saveAsCopy": "प्रतिलिपि के रूप में सहेजें",
    "gui.menuBar.remix": "रीमिक्स",
    "gui.menuBar.languageSelector": "भाषा चयनकर्ता",
    "gui.menuBar.tutorialsLibrary": "ट्यूटोरियल",
    "gui.menuBar.community": "खुला समुदाय",
    "gui.menuBar.wiki": "एजेंट डाउनलोड करें",
    "gui.menuBar.restoreSprite": "स्प्राइट पुनर्स्थापित करें",
    "gui.menuBar.restoreSound": "ध्वनि पुनर्स्थापित करें",
    "gui.menuBar.restoreCostume": "पोशाक पुनर्स्थापित करें",
    "gui.menuBar.restore": "पुनर्स्थापित करें",
    "gui.menuBar.turboModeOff": "टर्बो मोड बंद करें",
    "gui.menuBar.turboModeOn": "टर्बो मोड चालू करें",
    "gui.menuBar.noDeviceSelected": "कोई उपकरण चयनित नहीं",
    "gui.menuBar.noConnection": "असंबंधित",
    "gui.menuBar.downloadToComputer": "अपने कंप्यूटर पर सहेजें",
    "gui.menuBar.checkUpdate": "अद्यतन की जाँच करें",
    "gui.menuBar.installDriver": "ड्राइवर स्थापित करें",
    "gui.menuBar.clearCacheAndRestart": "कैश साफ़ करें और पुनः आरंभ करें",
    "gui.adblockModal.title": "विज्ञापन अवरोधक का पता चला",
    "gui.adblockModal.body":
        "TIFStudio को विज्ञापन अवरोधक द्वारा अवरुद्ध किया जा रहा है। कृपया TIFStudio के लिए विज्ञापन अवरोधक को अक्षम करें।",
    "gui.adblockModal.reload": "पुनः लोड करें",
    "gui.alerts.createsuccess": "नया प्रोजेक्ट बनाया गया।",
    "gui.alerts.createcopysuccess":
        "प्रोजेक्ट को प्रतिलिपि के रूप में सहेजा गया।",
    "gui.alerts.createremixsuccess":
        "प्रोजेक्ट को रीमिक्स के रूप में सहेजा गया।",
    "gui.alerts.creating": "नया बना रहा है...",
    "gui.alerts.creatingCopy": "प्रोजेक्ट की प्रतिलिपि बना रहा है...",
    "gui.alerts.creatingRemix": "प्रोजेक्ट का रीमिक्स बना रहा है...",
    "gui.alerts.downloading": "डाउनलोड हो रहा है...",
    "gui.alerts.loading": "लोड हो रहा है...",
    "gui.alerts.saving": "सहेजा जा रहा है...",
    "gui.alerts.savesuccess": "प्रोजेक्ट सहेजा गया।",
    "gui.alerts.savingError": "प्रोजेक्ट सहेजा नहीं जा सका।",
    "gui.alerts.cloudInfo":
        "कृपया ध्यान दें, क्लाउड वेरिएबल केवल संख्याओं का समर्थन करते हैं, अक्षरों या प्रतीकों का नहीं।",
    "gui.alerts.cloudVariableFull": "क्लाउड वेरिएबल सीमा तक पहुँच गया।",
    "gui.alerts.importedSvgTitle": "अपलोड की गई SVG फ़ाइल में समस्या",
    "gui.alerts.importedSvgMessage":
        "SVG फ़ाइल लोड नहीं की जा सकी। क्या यह एक वैध SVG फ़ाइल है?",
    "gui.alerts.importedSvgReset": "पुनः प्रयास करें",
    "gui.alerts.importedSvgCancel": "रद्द करें",
    "gui.alerts.uploadError": "अपलोड त्रुटि",
    "gui.alerts.uploadSuccess": "अपलोड सफल",
    "gui.gui.addExtension": "एक्सटेंशन जोड़ें",
    "gui.gui.code": "कोड",
    "gui.gui.backdrops": "पृष्ठभूमि",
    "gui.gui.costumes": "पोशाकें",
    "gui.gui.sounds": "ध्वनियाँ",
    "gui.gui.codeTab": "कोड",
    "gui.gui.costumesTab": "पोशाकें",
    "gui.gui.backdropsTab": "पृष्ठभूमि",
    "gui.gui.soundsTab": "ध्वनियाँ",
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.menuBar.turnOffCamera": "कैमरा बंद करें",
    "gui.menu-bar.realtimeMode": "स्क्रैच",
    "gui.menu-bar.programMode": "प्रोग्राम",
    "gui.hardwareConsole.send": "भेजें",
    "gui.hardwareConsole.buadrate": "बॉड दर",
    "gui.hardwareConsole.endOfLine": "पंक्ति का अंत",
    "gui.hardwareConsole.hexform": "हेक्स रूप",
    "gui.hardwareConsole.autoScroll": "ऑटो स्क्रॉल",
    "gui.hardwareHeader.upload": "अपलोड करें",
    "gui.stageHeader.codeStageSizeLarge": "बड़ा मंच",
    "gui.stageHeader.codeStageSizeSmall": "छोटा मंच",
    "gui.stageHeader.hideStage": "मंच छिपाएँ",
    "gui.stageHeader.fullscreenControl": "पूर्ण स्क्रीन नियंत्रण",
    "gui.extensionLibrary.comingSoon": "जल्द आ रहा है",
    "gui.extensionLibrary.requires": "आवश्यकता है",
    "gui.extensionLibrary.collaboration": "के सहयोग से",
    // Extension Library Metadata
    "gui.extensionLibrary.manufactor": "निर्माता",
    "gui.extensionLibrary.version": "संस्करण",
    "gui.extensionLibrary.author": "लेखक",
    "gui.extensionLibrary.programMode": "प्रोग्राम मोड",
    "gui.extensionLibrary.programLanguage": "प्रोग्रामिंग भाषा",
    "gui.extensionLibrary.deviceLearnMore": "अधिक जानें",
    "gui.extensionLibrary.extensionHelp": "मदद",
    "gui.extensionLibrary.Processing": "प्रसंस्करण...",
    "gui.extensionLibrary.loaded": "लोड किया गया",
    "gui.extensionLibrary.notLoaded": "लोड नहीं हुआ",
    "gui.extensionLibrary.chooseAnExtension": "एक एक्सटेंशन चुनें",
    // gui.library
    "gui.library.droneTag": "ड्रोन",
    "gui.library.filterPlaceholder": "खोजें",
    "gui.library.allTag": "सभी",
    "gui.library.readMore": "और पढ़ें",
    "gui.library.readLess": "कम पढ़ें",

    "gui.loader.message1": "स्प्राइट बना रहा है ...",
    "gui.loader.message2": "ध्वनियाँ लोड कर रहा है ...",
    "gui.loader.message3": "पोशाकें लोड कर रहा है ...",
    "gui.loader.message4": "एक्सटेंशन लोड कर रहा है ...",
    "gui.loader.message5": "ब्लॉक बना रहा है ...",
    "gui.loader.message6": "गणित कर रहा है ...",
    "gui.loader.message7": "लोड हो रहा है ...",
    "gui.loader.message8": "तैयार कर रहा है ...",
    "gui.loader.headline": "प्रोजेक्ट लोड हो रहा है",
    "gui.loader.creating": "प्रोजेक्ट बना रहा है",
    "gui.spriteLibrary.chooseASprite": "एक स्प्राइट चुनें",
    "gui.spriteLibrary.paintASprite": "पेंट",
    "gui.spriteLibrary.uploadASprite": "स्प्राइट अपलोड करें",
    "gui.spriteLibrary.surprise": "आश्चर्य",
    "gui.soundLibrary.chooseASound": "एक ध्वनि चुनें",
    "gui.soundLibrary.record": "रिकॉर्ड",
    "gui.soundLibrary.uploadASound": "ध्वनि अपलोड करें",
    "gui.costumeLibrary.chooseACostume": "एक पोशाक चुनें",
    "gui.costumeLibrary.paintACostume": "पेंट",
    "gui.costumeLibrary.uploadACostume": "पोशाक अपलोड करें",
    "gui.backdropLibrary.chooseABackdrop": "एक पृष्ठभूमि चुनें",
    "gui.backdropLibrary.paintABackdrop": "पेंट",
    "gui.backdropLibrary.uploadABackdrop": "पृष्ठभूमि अपलोड करें",
    "gui.spriteSelector.addSpriteFromLibrary": "एक स्प्राइट चुनें",
    "gui.spriteSelector.addSpriteFromPaint": "पेंट",
    "gui.spriteSelector.addSpriteFromSurprise": "आश्चर्य",
    "gui.spriteSelector.addSpriteFromFileUpload": "स्प्राइट अपलोड करें",
    "gui.stageSelector.addBackdropFromLibrary": "एक पृष्ठभूमि चुनें",
    "gui.stageSelector.addBackdropFromPaint": "पेंट",
    "gui.stageSelector.addBackdropFromSurprise": "आश्चर्य",
    "gui.stageSelector.addBackdropFromFileUpload": "पृष्ठभूमि अपलोड करें",
    "gui.stageSelector.stage": "मंच",
    "gui.stageSelector.backdrops": "पृष्ठभूमि",
    "gui.spriteSelectorItem.contextMenuDuplicate": "प्रतिलिपि बनाएँ",
    "gui.spriteSelectorItem.contextMenuExport": "निर्यात",
    "gui.spriteSelectorItem.contextMenuDelete": "हटाएँ",
    "gui.spriteInfo.sprite": "स्प्राइट",
    "gui.spriteInfo.size": "आकार",
    "gui.spriteInfo.show": "दिखाएँ",
    "gui.spriteInfo.changeSize": "आकार बदलें",
    "gui.spriteInfo.changeX": "X बदलें",
    "gui.spriteInfo.changeY": "Y बदलें",
    "gui.spriteInfo.direction": "दिशा",
    "gui.spriteInfo.changeDirection": "दिशा बदलें",
    "gui.spriteInfo.isVisible": "दिख रहा है",
    "gui.deviceLibrary.chooseADevice": "एक उपकरण चुनें",
    "gui.deviceLibrary.deviceUrl": "डिवाइस URL दर्ज करें",
    "gui.deviceLibrary.arduinoTag": "Arduino",
    "gui.deviceLibrary.microbitTag": "Micro:bit",
    "gui.deviceLibrary.esp32Tag": "ESP32",
    "gui.deviceLibrary.kitTag": "किट",
    "gui.deviceLibrary.shieldTag": "शील्ड",
    "gui.playButton.play": "चलाएँ",
    "gui.playButton.stop": "रोकें",
    "gui.gui.variableScopeOptionAllSprites": "सभी स्प्राइट के लिए",
    "gui.gui.variableScopeOptionSpriteOnly": "केवल इस स्प्राइट के लिए",
    "gui.gui.cloudVariableOption": "क्लाउड वेरिएबल (सर्वर पर संग्रहीत)",
    "gui.gui.variablePromptDefaultValue": "मेरा वेरिएबल",
    "gui.gui.listVariable": "एक सूची बनाएँ",
    "gui.gui.makeAVariable": "एक वेरिएबल बनाएँ",
    "gui.gui.newVariable": "नया वेरिएबल",
    "gui.soundEditor.sound": "ध्वनि",
    "gui.soundEditor.play": "चलाएँ",
    "gui.soundEditor.stop": "रोकें",
    "gui.soundEditor.copy": "कॉपी",
    "gui.soundEditor.paste": "पेस्ट",
    "gui.soundEditor.copyToNew": "नए में कॉपी करें",
    "gui.soundEditor.delete": "हटाएँ",
    "gui.soundEditor.save": "सहेजें",
    "gui.soundEditor.undo": "पूर्ववत करें",
    "gui.soundEditor.redo": "फिर से करें",
    "gui.soundEditor.faster": "तेज़",
    "gui.soundEditor.slower": "धीमा",
    "gui.soundEditor.echo": "गूँज",
    "gui.soundEditor.robot": "रोबोट",
    "gui.soundEditor.louder": "तेज़ आवाज़",
    "gui.soundEditor.softer": "धीमी आवाज़",
    "gui.soundEditor.reverse": "उल्टा",
    "gui.soundEditor.fadeOut": "फ़ेड आउट",
    "gui.soundEditor.fadeIn": "फ़ेड इन",
    "gui.soundEditor.mute": "म्यूट",
    "paint.paintEditor.hue": "रंग",
    "paint.paintEditor.saturation": "संतृप्ति",
    "paint.paintEditor.brightness": "चमक",
    "paint.paintEditor.fill": "भरें",
    "paint.paintEditor.costume": "पोशाक",
    "paint.paintEditor.group": "समूह",
    "paint.paintEditor.ungroup": "समूह हटाएँ",
    "paint.paintEditor.undo": "पूर्ववत करें",
    "paint.paintEditor.redo": "फिर से करें",
    "paint.paintEditor.forward": "सामने लाएँ",
    "paint.paintEditor.backward": "पीछे भेजें",
    "paint.paintEditor.front": "सबसे सामने",
    "paint.paintEditor.back": "सबसे पीछे",
    "paint.paintEditor.more": "अधिक",
    "paint.modeTools.brushSize": "ब्रश का आकार",
    "paint.modeTools.eraserSize": "इरेज़र का आकार",
    "paint.modeTools.copy": "कॉपी",
    "paint.modeTools.paste": "पेस्ट",
    "paint.modeTools.delete": "हटाएँ",
    "paint.modeTools.curved": "वक्र",
    "paint.modeTools.pointed": "नुकीला",
    "paint.modeTools.thickness": "मोटाई",
    "paint.modeTools.flipHorizontal": "क्षैतिज पलटें",
    "paint.modeTools.flipVertical": "लंबवत पलटें",
    "paint.modeTools.filled": "भरा हुआ",
    "paint.modeTools.outlined": "रूपरेखा",
    "paint.paintEditor.bitmap": "बिटमैप में बदलें",
    "paint.paintEditor.vector": "वेक्टर में बदलें",
    "paint.paintEditor.stroke": "रूपरेखा",
    "paint.brushMode.brush": "ब्रश",
    "paint.eraserMode.eraser": "इरेज़र",
    "paint.fillMode.fill": "भरें",
    "paint.lineMode.line": "रेखा",
    "paint.ovalMode.oval": "वृत्त",
    "paint.rectMode.rect": "आयत",
    "paint.reshapeMode.reshape": "आकार बदलें",
    "paint.roundedRectMode.roundedRect": "गोल आयत",
    "paint.selectMode.select": "चुनें",
    "paint.textMode.text": "पाठ",
    "paint.colorPicker.swap": "स्वैप",
    "gui.uploadProgress.uploading": "अपलोड हो रहा है",
    "gui.uploadProgress.uploadSuccess": "अपलोड सफल",
    "gui.uploadProgress.uploadError": "अपलोड त्रुटि",
    "gui.uploadProgress.close": "बंद करें",
    "gui.uploadProgress.abort": "रद्द करें",
    "gui.connection.connect": "कनेक्ट करें",
    "gui.connection.disconnect": "डिस्कनेक्ट करें",
    "gui.connection.connected": "कनेक्टेड",
    "gui.connection.connecting": "कनेक्ट हो रहा है...",
    "gui.connection.error": "त्रुटि",
    "gui.connection.unavailable": "अनुपलब्ध",
    "gui.connection.noDevicesFound": "कोई उपकरण नहीं मिला",
    "gui.connection.scanning": "स्कैन कर रहा है...",
    "gui.connection.help": "मदद",
    "gui.connection.refresh": "ताज़ा करें",
    "blockly.deleteBlock": "ब्लॉक हटाएँ",
    "blockly.duplicateBlock": "प्रतिलिपि बनाएँ",
    "blockly.addComment": "टिप्पणी जोड़ें",
    "blockly.removeComment": "टिप्पणी हटाएँ",
    "blockly.externalInput": "बाहरी इनपुट",
    "blockly.inlineInput": "इनलाइन इनपुट",
    "blockly.disableBlock": "ब्लॉक अक्षम करें",
    "blockly.enableBlock": "ब्लॉक सक्षम करें",
    "blockly.expandBlock": "ब्लॉक विस्तृत करें",
    "blockly.collapseBlock": "ब्लॉक संक्षिप्त करें",
    "blockly.help": "मदद",
    "blockly.undo": "पूर्ववत करें",
    "blockly.redo": "फिर से करें",
    "blockly.cleanUp": "ब्लॉकों को व्यवस्थित करें",
    "blockly.sortByCategory": "श्रेणी के अनुसार सॉर्ट करें",
    "blockly.workspaceComment": "वर्कस्पेस टिप्पणी",
    "blockly.exportToHtml": "HTML के रूप में निर्यात करें",
    "blockly.snapToGrid": "ग्रिड पर चिपकाएँ",
    "blockly.cannotDeleteVariable": "इस वेरिएबल को हटाया नहीं जा सकता",
    "blockly.renameVariable": "वेरिएबल का नाम बदलें",
    "blockly.newVariable": "नया वेरिएबल",
    "blockly.renameVariableTitle": 'सभी "%1" वेरिएबल का नाम बदलें:',
    "blockly.variableAlreadyExists": '"%1" नाम का वेरिएबल पहले से मौजूद है',

    // Device translations
    "gui.device.unselectDevice.name": "डिवाइस अचयनित करें",
    "gui.device.unselectDevice.description":
        "डिवाइस को अचयनित करें, शुद्ध रीयलटाइम प्रोग्रामिंग मोड में लौटें।",
    "gui.device.connectingMessage": "कनेक्ट हो रहा है",
    "gui.device.arduinoUno.description":
        "इलेक्ट्रॉनिक्स और कोडिंग के साथ शुरुआत करने के लिए एक बेहतरीन बोर्ड।",
    "gui.device.arduinoNano.description":
        "Arduino Nano आपकी परियोजनाओं को बनाने के लिए एक क्लासिक छोटा बोर्ड है।",
    "gui.device.arduinoLeonardo.description":
        "क्लासिक Arduino बोर्ड जो माउस या कीबोर्ड के रूप में कार्य कर सकता है।",
    "gui.device.arduinoMega2560.description":
        "54 डिजिटल पिन, 16 एनालॉग इनपुट और 4 सीरियल पोर्ट वाला 8-बिट बोर्ड।",
    "gui.device.arduinoUnoR4Minima.description":
        "बेहतर प्रदर्शन और विस्तारित मेमोरी प्रदान करता है, मौजूदा शील्ड और एक्सेसरीज के साथ संगतता बनाए रखता है।",
    "gui.device.arduinoUnoR4Wifi.description":
        "Wi-Fi और Bluetooth कनेक्टिविटी प्रदान करता है, साथ ही विज़ुअलाइज़ेशन के लिए ऑन-बोर्ड 12x8 LED मैट्रिक्स।",
    "gui.device.esp32.description":
        "समृद्ध कार्यों के साथ Wi-Fi और Bluetooth नियंत्रण बोर्ड।",
    "gui.device.esp32S3.description":
        "कुशल, कम-शक्ति IoT एज और AI वर्कलोड के लिए समर्पित AI एक्सेलेरेटर और समृद्ध परिधीय सेट को एकीकृत करता है।",
    "gui.device.esp8266NodeMCU.description":
        "कम लागत वाला Wi-Fi SOC नियंत्रण बोर्ड।",
    "gui.device.k210MaixDock.description":
        "K210 RISC-V चिप पर आधारित एक नियंत्रण बोर्ड जिसमें केवल बुनियादी कार्य हैं और सभी IO पिन निकाले गए हैं।",
    "gui.device.k210Maixduino.description": "ESP32 के साथ K210 RISC-V बोर्ड।",
    "gui.device.raspberryPiPicoIconURL.description":
        "एक मित्रवत, उपयोग में आसान माइक्रोकंट्रोलर बोर्ड जो आपके इलेक्ट्रॉनिक्स विचारों को जीवन में लाता है।",
    "gui.device.raspberryPiPicoWIconURL.description":
        "बिल्ट-इन 2.4 GHz Wi-Fi और Bluetooth 5.2 के साथ एक Pico, वायरलेस और IoT परियोजनाओं के लिए बिल्कुल सही।",
    "gui.device.raspberryPiPico2IconURL.description":
        "जटिल अनुप्रयोगों के लिए पर्याप्त RAM और फ्लैश के साथ उच्च-प्रदर्शन डुअल-कोर MCU।",
    "gui.device.raspberryPiPico2WIconURL.description":
        "निर्बाध वायरलेस IoT और स्मार्ट-होम एकीकरण के लिए बिल्ट-इन 2.4 GHz Wi-Fi और Bluetooth।",
    "gui.device.microbit.description":
        "डिजिटल कौशल सीखने को बदलने वाला पॉकेट-आकार का कंप्यूटर।",
    "gui.device.microbitV2.description":
        "उन्नत प्रोसेसर, बिल्ट-इन स्पीकर और माइक्रोफोन, टच संवेदनशील लोगो।",
    "gui.device.makeymakey.description": "किसी भी चीज़ को एक कुंजी में बदलें।",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.device.tifBot.description":
        "TIF-BOT एक ESP32-S3 आधारित बोर्ड है जिसमें Wi-Fi, Bluetooth और रोबोटिक्स तथा IoT प्रोजेक्ट्स के लिए 풍丰富的 peripherals हैं।",
    "gui.device.lightWingDrone.description":
        "Lite Wing Drone एक उच्च-प्रदर्शन ESP32-S3 आधारित फ्लाइट कंट्रोलर है जिसमें एडवांस्ड स्टेबिलाइजेशन और Wi-Fi कंट्रोल है।",
    "gui.device.roboticDog.description":
        "Robotic Dog एक स्मार्ट चौपाया रोबोट है जो Arduino Nano द्वारा संचालित है, जो जीवन जैसी गतिविधियाँ और बाधा से बचाव करने में सक्षम है।",
    "gui.device.roboticArm.description":
        "Robotic Arm एक मल्टी-एक्सिस मैनिपुलेटर है जो Arduino Nano द्वारा संचालित है, जो सटीक कार्यों और ऑटोमेशन सीखने के लिए डिज़ाइन किया गया है।",
    // Music
    "music.categoryName": "संगीत",
    "music.playDrumForBeats": "ड्रम [DRUM] [BEATS] बीट्स के लिए बजाएं",
    "music.restForBeats": "[BEATS] बीट्स के लिए रुकें",
    "music.playNoteForBeats": "नोट [NOTE] [BEATS] बीट्स के लिए बजाएं",
    "music.setInstrument": "वाद्ययंत्र [INSTRUMENT] सेट करें",
    "music.changeTempo": "टेम्पो को [TEMPO] से बदलें",
    "music.setTempo": "टेम्पो को [TEMPO] पर सेट करें",
    "music.getTempo": "टेम्पो",
    "music.drumBass": "(2) बास ड्रम",
    "music.drumBongo": "(13) बोंगो",
    "music.drumCabasa": "(15) कबासा",
    "music.drumClaves": "(9) क्लेव्स",
    "music.drumClosedHiHat": "(6) बंद हाई-हैट",
    "music.drumConga": "(14) कोंगा",
    "music.drumCowbell": "(11) काउबेल",
    "music.drumCrashCymbal": "(4) क्रैश सिम्बल",
    "music.drumCuica": "(18) कुइतसा",
    "music.drumGuiro": "(16) गुइरो",
    "music.drumHandClap": "(8) ताली",
    "music.drumOpenHiHat": "(5) खुला हाई-हैट",
    "music.drumSideStick": "(3) साइड स्टिक",
    "music.drumSnare": "(1) स्नेयर ड्रम",
    "music.drumTambourine": "(7) डफ़ली",
    "music.drumTriangle": "(12) ट्राएंगल",
    "music.drumVibraslap": "(17) वाइब्रास्लैप",
    "music.drumWoodBlock": "(10) वुड ब्लॉक",
    "music.instrumentBass": "(6) बास",
    "music.instrumentBassoon": "(14) बासून",
    "music.instrumentCello": "(8) सेलो",
    "music.instrumentChoir": "(15) गायक मंडली",
    "music.instrumentClarinet": "(10) शहनाई",
    "music.instrumentElectricGuitar": "(5) इलेक्ट्रिक गिटार",
    "music.instrumentElectricPiano": "(2) इलेक्ट्रिक पियानो",
    "music.instrumentFlute": "(12) बांसुरी",
    "music.instrumentGuitar": "(4) गिटार",
    "music.instrumentMarimba": "(19) मारिम्बा",
    "music.instrumentMusicBox": "(17) म्यूजिक बॉक्स",
    "music.instrumentOrgan": "(3) ऑर्गन",
    "music.instrumentPiano": "(1) पियानो",
    "music.instrumentPizzicato": "(7) पिज्ज़िकाटो",
    "music.instrumentSaxophone": "(11) सैक्सोफोन",
    "music.instrumentSteelDrum": "(18) स्टील ड्रम",
    "music.instrumentSynthLead": "(20) सिंथ लीड",
    "music.instrumentSynthPad": "(21) सिंथ पैड",
    "music.instrumentTrombone": "(9) ट्रॉम्बोन",
    "music.instrumentVibraphone": "(16) वाइब्राफोन",
    "music.instrumentWoodenFlute": "(13) लकड़ी की बांसुरी",

    // Pen
    "pen.categoryName": "पेन",
    "pen.clear": "सब मिटाएं",
    "pen.stamp": "स्टैम्प",
    "pen.penDown": "पेन नीचे",
    "pen.penUp": "पेन ऊपर",
    "pen.setColor": "पेन का रंग [COLOR] सेट करें",
    "pen.changeSize": "पेन का आकार [SIZE] से बदलें",
    "pen.setSize": "पेन का आकार [SIZE] पर सेट करें",
    "pen.colorMenu.color": "रंग",
    "pen.colorMenu.saturation": "संतृप्ति (saturation)",
    "pen.colorMenu.brightness": "चमक (brightness)",
    "pen.colorMenu.transparency": "पारदर्शिता",

    // Video Sensing
    "videoSensing.categoryName": "वीडियो सेंसिंग",
    "videoSensing.videoToggle": "वीडियो [VIDEO_STATE] करें",
    "videoSensing.setVideoTransparency":
        "वीडियो पारदर्शिता [TRANSPARENCY] सेट करें",
    "videoSensing.whenMotionGreaterThan": "जब वीडियो मोशन > [REFERENCE]",
    "videoSensing.videoOn": "[SUBJECT] पर वीडियो [ATTRIBUTE]",
    "videoSensing.on": "चालू",
    "videoSensing.off": "बंद",
    "videoSensing.onFlipped": "फ्लिप करके चालू",

    // Face Sensing (poseFace)
    "poseFace.name": "फेस सेंसिंग",
    "poseFace.affdexGoToPart": "[AFFDEX_POINT] पर जाएं",
    "poseFace.affdexReturnPart": "[AFFDEX_POINT] से [COORD] प्राप्त करें",
    "poseFace.affdexWhenExpression": "जब [EXPRESSION] का पता चले",
    "poseFace.affdexExpressionAmount": "[EXPRESSION] की मात्रा",
    "poseFace.affdexIsExpression": "[EXPRESSION] व्यक्त कर रहा है?",
    "poseFace.affdexWhenEmotion": "जब [EMOTION] भावना का पता चले",
    "poseFace.affdexEmotionAmount": "[EMOTION_ALL] का स्तर",
    "poseFace.affdexIsTopEmotion": "[EMOTION] महसूस कर रहा है?",

    // Hand Sensing (poseHand)
    "poseHand.name": "हैंड सेंसिंग",
    "poseHand.goToHandPart": "[HAND_PART] [HAND_SUB_PART] पर जाएं",
    "poseHand.returnHandPart":
        "[HAND_PART] [HAND_SUB_PART] से [COORD] प्राप्त करें",

    // Body Pose Sensing
    "poseBody.name": "बॉडी पोज़ सेंसिंग",

    // Text to Speech
    "text2speech.categoryName": "टेक्स्ट टू स्पीच",
    "text2speech.speakAndWaitBlock": "बोलें [WORDS]",
    "text2speech.setVoiceBlock": "आवाज़ [VOICE] सेट करें",
    "text2speech.setLanguageBlock": "भाषा [LANGUAGE] सेट करें",
    "text2speech.alto": "अल्टो",
    "text2speech.tenor": "टेनर",
    "text2speech.squeak": "चीख़ना",
    "text2speech.giant": "विशाल",
    "text2speech.kitten": "बिल्ली का बच्चा",

    // Translate
    "translate.categoryName": "अनुवाद",
    "translate.translateBlock": "[WORDS] का [LANGUAGE] में अनुवाद करें",
    "translate.viewerLanguage": "भाषा",

    // Extension Library Names and Descriptions
    "gui.extension.music.name": "संगीत",
    "gui.extension.music.description": "वाद्ययंत्र और ड्रम बजाएं।",
    "gui.extension.pen.name": "पेन",
    "gui.extension.pen.description": "अपने स्प्राइट के साथ चित्र बनाएं।",
    "gui.extension.videosensing.name": "वीडियो सेंसिंग",
    "gui.extension.videosensing.description": "कैमरे के साथ गति को महसूस करें।",
    "gui.extension.poseface.name": "फेस सेंसिंग",
    "gui.extension.poseface.description":
        "कैमरे के साथ चेहरे की गति को महसूस करें।",
    "gui.extension.posehand.name": "हैंड सेंसिंग",
    "gui.extension.posehand.description":
        "कैमरे के साथ हाथ की हलचल को महसूस करें।",
    "gui.extension.posebody.name": "बॉडी पोज़ सेंसिंग",
    "gui.extension.posebody.description":
        "कैमरे के साथ शरीर की हलचल को महसूस करें।",
    "gui.extension.teachablemachine.name": "टीचेबल मशीन",
    "gui.extension.teachablemachine.description":
        "अपने कैमरे के साथ कस्टम मशीन लर्निंग मॉडल का उपयोग करें।",
    "gui.extension.text2speech.name": "टेक्स्ट टू स्पीच",
    "gui.extension.text2speech.description": "अपने प्रोजेक्ट को बुलवाएं।",
    "gui.extension.translate.name": "अनुवाद",
    "gui.extension.translate.description": "पाठ का कई भाषाओं में अनुवाद करें।",
    "gui.extension.makeymakey.name": "मैकी मैकी",
    "gui.extension.makeymakey.description": "किसी भी चीज़ को एक कुंजी बनाएं।",

    // Arduino Translations
    "arduinoUno.category.pins": "पिन",
    "arduinoUno.category.serial": "सीरियल",
    "arduinoUno.category.data": "डेटा",

    "arduinoNano.category.pins": "पिन",
    "arduinoNano.category.serial": "सीरियल",
    "arduinoNano.category.data": "डेटा",

    "arduinoLeonardo.category.pins": "पिन",
    "arduinoLeonardo.category.serial": "सीरियल",
    "arduinoLeonardo.category.data": "डेटा",

    "arduinoMega2560.category.pins": "पिन",
    "arduinoMega2560.category.serial": "सीरियल",
    "arduinoMega2560.category.data": "डेटा",

    "arduinoEsp32.category.pins": "पिन",
    "arduinoEsp32.category.serial": "सीरियल",
    "arduinoEsp32.category.data": "डेटा",

    "arduinoEsp8266.category.pins": "पिन",
    "arduinoEsp8266.category.serial": "सीरियल",
    "arduinoEsp8266.category.data": "डेटा",

    "arduinoK210.category.pins": "पिन",
    "arduinoK210.category.serial": "सीरियल",
    "arduinoK210.category.data": "डेटा",

    "arduinoRaspberryPiPico.category.pins": "पिन",
    "arduinoRaspberryPiPico.category.serial": "सीरियल",
    "arduinoRaspberryPiPico.category.data": "डेटा",

    // Arduino Uno Blocks
    "arduinoUno.modeMenu.input": "इनपुट",
    "arduinoUno.modeMenu.output": "आउटपुट",
    "arduinoUno.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoUno.levelMenu.high": "हाई",
    "arduinoUno.levelMenu.low": "लो",
    "arduinoUno.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करें",
    "arduinoUno.pins.setDigitalOutput": "डिजिटल पिन [PIN] आउट [LEVEL] सेट करें",
    "arduinoUno.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करें",
    "arduinoUno.pins.readDigitalPin": "डिजिटल पिन [PIN] पढ़ें",
    "arduinoUno.pins.readAnalogPin": "एनालॉग पिन [PIN] पढ़ें",
    "arduinoUno.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करें",
    "arduinoUno.pins.attachInterrupt":
        "इन्टर्रप्ट पिन [PIN] मोड [MODE] अटैच करें",
    "arduinoUno.pins.detachInterrupt": "इन्टर्रप्ट पिन [PIN] डिटैच करें",
    "arduinoUno.serial.serialBegin": "सीरियल बेगिन बॉडरेट [VALUE]",
    "arduinoUno.serial.serialPrint": "सीरियल प्रिंट [VALUE] [EOL]",
    "arduinoUno.serial.serialAvailable": "सीरियल उपलब्ध डेटा लेन्थ",
    "arduinoUno.serial.serialReadAByte": "सीरियल एक बाइट पढ़ें",
    "arduinoUno.data.dataMap":
        "[DATA] को ([ARG0], [ARG1]) से ([ARG2], [ARG3]) में मैप करें",

    // Arduino Nano Blocks (Assuming duplication of Uno keys or Nano specific keys if they exist)
    "arduinoNano.modeMenu.input": "इनपुट",
    "arduinoNano.modeMenu.output": "आउटपुट",
    "arduinoNano.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoNano.levelMenu.high": "हाई",
    "arduinoNano.levelMenu.low": "लो",
    "arduinoNano.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करें",
    "arduinoNano.pins.setDigitalOutput":
        "डिजिटल पिन [PIN] आउट [LEVEL] सेट करें",
    "arduinoNano.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करें",
    "arduinoNano.pins.readDigitalPin": "डिजिटल पिन [PIN] पढ़ें",
    "arduinoNano.pins.readAnalogPin": "एनालॉग पिन [PIN] पढ़ें",
    "arduinoNano.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करें",
    "arduinoNano.pins.attachInterrupt":
        "इन्टर्रप्ट पिन [PIN] मोड [MODE] अटैच करें",
    "arduinoNano.pins.detachInterrupt": "इन्टर्रप्ट पिन [PIN] डिटैच करें",
    "arduinoNano.serial.serialBegin": "सीरियल बेगिन बॉडरेट [VALUE]",
    "arduinoNano.serial.serialPrint": "सीरियल प्रिंट [VALUE] [EOL]",
    "arduinoNano.serial.serialAvailable": "सीरियल उपलब्ध डेटा लेन्थ",
    "arduinoNano.serial.serialReadAByte": "सीरियल एक बाइट पढ़ें",
    "arduinoNano.data.dataMap":
        "[DATA] को ([ARG0], [ARG1]) से ([ARG2], [ARG3]) में मैप करें",

    // Arduino Leonardo Blocks
    "arduinoLeonardo.modeMenu.input": "इनपुट",
    "arduinoLeonardo.modeMenu.output": "आउटपुट",
    "arduinoLeonardo.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoLeonardo.levelMenu.high": "हाई",
    "arduinoLeonardo.levelMenu.low": "लो",
    "arduinoLeonardo.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करें",
    "arduinoLeonardo.pins.setDigitalOutput":
        "डिजिटल पिन [PIN] आउट [LEVEL] सेट करें",
    "arduinoLeonardo.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करें",
    "arduinoLeonardo.pins.readDigitalPin": "डिजिटल पिन [PIN] पढ़ें",
    "arduinoLeonardo.pins.readAnalogPin": "एनालॉग पिन [PIN] पढ़ें",
    "arduinoLeonardo.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करें",
    "arduinoLeonardo.pins.attachInterrupt":
        "इन्टर्रप्ट पिन [PIN] मोड [MODE] अटैच करें",
    "arduinoLeonardo.pins.detachInterrupt": "इन्टर्रप्ट पिन [PIN] डिटैच करें",
    "arduinoLeonardo.serial.serialBegin": "सीरियल बेगिन बॉडरेट [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "सीरियल प्रिंट [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialAvailable": "सीरियल उपलब्ध डेटा लेन्थ",
    "arduinoLeonardo.serial.serialReadAByte": "सीरियल एक बाइट पढ़ें",
    "arduinoLeonardo.data.dataMap":
        "[DATA] को ([ARG0], [ARG1]) से ([ARG2], [ARG3]) में मैप करें",

    // Arduino Mega2560 Blocks
    "arduinoMega2560.modeMenu.input": "इनपुट",
    "arduinoMega2560.modeMenu.output": "आउटपुट",
    "arduinoMega2560.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoMega2560.levelMenu.high": "हाई",
    "arduinoMega2560.levelMenu.low": "लो",
    "arduinoMega2560.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करें",
    "arduinoMega2560.pins.setDigitalOutput":
        "डिजिटल पिन [PIN] आउट [LEVEL] सेट करें",
    "arduinoMega2560.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करें",
    "arduinoMega2560.pins.readDigitalPin": "डिजिटल पिन [PIN] पढ़ें",
    "arduinoMega2560.pins.readAnalogPin": "एनालॉग पिन [PIN] पढ़ें",
    "arduinoMega2560.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करें",
    "arduinoMega2560.pins.attachInterrupt":
        "इन्टर्रप्ट पिन [PIN] मोड [MODE] अटैच करें",
    "arduinoMega2560.pins.detachInterrupt": "इन्टर्रप्ट पिन [PIN] डिटैच करें",
    "arduinoMega2560.serial.serialBegin": "सीरियल बेगिन बॉडरेट [VALUE]",
    "arduinoMega2560.serial.serialPrint": "सीरियल प्रिंट [VALUE] [EOL]",
    "arduinoMega2560.serial.serialAvailable": "सीरियल उपलब्ध डेटा लेन्थ",
    "arduinoMega2560.serial.serialReadAByte": "सीरियल एक बाइट पढ़ें",
    "arduinoMega2560.data.dataMap":
        "[DATA] को ([ARG0], [ARG1]) से ([ARG2], [ARG3]) में मैप करें",

    // Arduino ESP32 Blocks
    "arduinoEsp32.modeMenu.input": "इनपुट",
    "arduinoEsp32.modeMenu.output": "आउटपुट",
    "arduinoEsp32.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoEsp32.levelMenu.high": "हाई",
    "arduinoEsp32.levelMenu.low": "लो",
    "arduinoEsp32.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करें",
    "arduinoEsp32.pins.setDigitalOutput":
        "डिजिटल पिन [PIN] आउट [LEVEL] सेट करें",
    "arduinoEsp32.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करें",
    "arduinoEsp32.pins.readDigitalPin": "डिजिटल पिन [PIN] पढ़ें",
    "arduinoEsp32.pins.readAnalogPin": "एनालॉग पिन [PIN] पढ़ें",
    "arduinoEsp32.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करें",
    "arduinoEsp32.pins.attachInterrupt":
        "इन्टर्रप्ट पिन [PIN] मोड [MODE] अटैच करें",
    "arduinoEsp32.pins.detachInterrupt": "इन्टर्रप्ट पिन [PIN] डिटैच करें",
    "arduinoEsp32.serial.serialBegin": "सीरियल बेगिन बॉडरेट [VALUE]",
    "arduinoEsp32.serial.serialPrint": "सीरियल प्रिंट [VALUE] [EOL]",
    "arduinoEsp32.serial.serialAvailable": "सीरियल उपलब्ध डेटा लेन्थ",
    "arduinoEsp32.serial.serialReadAByte": "सीरियल एक बाइट पढ़ें",
    "arduinoEsp32.data.dataMap":
        "[DATA] को ([ARG0], [ARG1]) से ([ARG2], [ARG3]) में मैप करें",

    // Arduino ESP8266 Blocks
    "arduinoEsp8266.modeMenu.input": "इनपुट",
    "arduinoEsp8266.modeMenu.output": "आउटपुट",
    "arduinoEsp8266.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoEsp8266.levelMenu.high": "हाई",
    "arduinoEsp8266.levelMenu.low": "लो",
    "arduinoEsp8266.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करें",
    "arduinoEsp8266.pins.setDigitalOutput":
        "डिजिटल पिन [PIN] आउट [LEVEL] सेट करें",
    "arduinoEsp8266.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करें",
    "arduinoEsp8266.pins.readDigitalPin": "डिजिटल पिन [PIN] पढ़ें",
    "arduinoEsp8266.pins.readAnalogPin": "एनालॉग पिन [PIN] पढ़ें",
    "arduinoEsp8266.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करें",
    "arduinoEsp8266.pins.attachInterrupt":
        "इन्टर्रप्ट पिन [PIN] मोड [MODE] अटैच करें",
    "arduinoEsp8266.pins.detachInterrupt": "इन्टर्रप्ट पिन [PIN] डिटैच करें",
    "arduinoEsp8266.serial.serialBegin": "सीरियल बेगिन बॉडरेट [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "सीरियल प्रिंट [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialAvailable": "सीरियल उपलब्ध डेटा लेन्थ",
    "arduinoEsp8266.serial.serialReadAByte": "सीरियल एक बाइट पढ़ें",
    "arduinoEsp8266.data.dataMap":
        "[DATA] को ([ARG0], [ARG1]) से ([ARG2], [ARG3]) में मैप करें",
    // Additional Data Blocks
    "arduinoUno.data.dataConstrain":
        "[DATA] को ([ARG0], [ARG1]) के बीच सीमित करें",
    "arduinoUno.data.dataConvert": "[DATA] को [TYPE] में बदलें",
    "arduinoUno.data.dataConvertASCIICharacter":
        "[DATA] को ASCII अक्षर में बदलें",
    "arduinoUno.data.dataConvertASCIINumber":
        "[DATA] को ASCII संख्या में बदलें",
    "arduinoUno.dataTypeMenu.integer": "पूर्णांक",
    "arduinoUno.dataTypeMenu.decimal": "दशमलव",
    "arduinoUno.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoNano.data.dataConstrain":
        "[DATA] को ([ARG0], [ARG1]) के बीच सीमित करें",
    "arduinoNano.data.dataConvert": "[DATA] को [TYPE] में बदलें",
    "arduinoNano.data.dataConvertASCIICharacter":
        "[DATA] को ASCII अक्षर में बदलें",
    "arduinoNano.data.dataConvertASCIINumber":
        "[DATA] को ASCII संख्या में बदलें",
    "arduinoNano.dataTypeMenu.integer": "पूर्णांक",
    "arduinoNano.dataTypeMenu.decimal": "दशमलव",
    "arduinoNano.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoLeonardo.data.dataConstrain":
        "[DATA] को ([ARG0], [ARG1]) के बीच सीमित करें",
    "arduinoLeonardo.data.dataConvert": "[DATA] को [TYPE] में बदलें",
    "arduinoLeonardo.data.dataConvertASCIICharacter":
        "[DATA] को ASCII अक्षर में बदलें",
    "arduinoLeonardo.data.dataConvertASCIINumber":
        "[DATA] को ASCII संख्या में बदलें",
    "arduinoLeonardo.dataTypeMenu.integer": "पूर्णांक",
    "arduinoLeonardo.dataTypeMenu.decimal": "दशमलव",
    "arduinoLeonardo.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoMega2560.data.dataConstrain":
        "[DATA] को ([ARG0], [ARG1]) के बीच सीमित करें",
    "arduinoMega2560.data.dataConvert": "[DATA] को [TYPE] में बदलें",
    "arduinoMega2560.data.dataConvertASCIICharacter":
        "[DATA] को ASCII अक्षर में बदलें",
    "arduinoMega2560.data.dataConvertASCIINumber":
        "[DATA] को ASCII संख्या में बदलें",
    "arduinoMega2560.dataTypeMenu.integer": "पूर्णांक",
    "arduinoMega2560.dataTypeMenu.decimal": "दशमलव",
    "arduinoMega2560.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoEsp32.data.dataConstrain":
        "[DATA] को ([ARG0], [ARG1]) के बीच सीमित करें",
    "arduinoEsp32.data.dataConvert": "[DATA] को [TYPE] में बदलें",
    "arduinoEsp32.data.dataConvertASCIICharacter":
        "[DATA] को ASCII अक्षर में बदलें",
    "arduinoEsp32.data.dataConvertASCIINumber":
        "[DATA] को ASCII संख्या में बदलें",
    "arduinoEsp32.dataTypeMenu.integer": "पूर्णांक",
    "arduinoEsp32.dataTypeMenu.decimal": "दशमलव",
    "arduinoEsp32.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoEsp8266.data.dataConstrain":
        "[DATA] को ([ARG0], [ARG1]) के बीच सीमित करें",
    "arduinoEsp8266.data.dataConvert": "[DATA] को [TYPE] में बदलें",
    "arduinoEsp8266.data.dataConvertASCIICharacter":
        "[DATA] को ASCII अक्षर में बदलें",
    "arduinoEsp8266.data.dataConvertASCIINumber":
        "[DATA] को ASCII संख्या में बदलें",
    "arduinoEsp8266.dataTypeMenu.integer": "पूर्णांक",
    "arduinoEsp8266.dataTypeMenu.decimal": "दशमलव",
    "arduinoEsp8266.dataTypeMenu.string": "स्ट्रिंग",

    //Library manager
    "gui.librariesBoardsTab": "लाइब्रेरीज़",
    "gui.boardManagerTab": "बोर्ड मैनेजर",
    
    "gui.boardManager.title": "बोर्ड मैनेजर",
    "gui.boardManager.description":
        "आधिकारिक Arduino बोर्ड खोजें और इंस्टॉल करें।",
    "gui.boardManager.searchPlaceholder": "Arduino बोर्ड खोजें (उदाहरण: esp32)",
    "gui.boardManager.search": "खोजें",
    "gui.boardManager.searching": "खोज रहे हैं...",
    "gui.boardManager.advancedOptionsShow":
        "▶ उन्नत विकल्प (कस्टम इंस्टॉल पाथ)",
    "gui.boardManager.advancedOptionsHide": "▼ उन्नत विकल्प छिपाएं",
    "gui.boardManager.recommended": "अनुशंसित",
    "gui.boardManager.installed": "इंस्टॉल किए गए ({count})",
    "gui.boardManager.searchResults": "खोज परिणाम {count}",
    "gui.boardManager.refresh": "↻ रीफ्रेश",
    "gui.boardManager.refreshing": "↻ रीफ्रेश हो रहा है...",
    
    // Library manager
    "gui.libraryManager.title": "लाइब्रेरी मैनेजर",
    "gui.libraryManager.description": "आधिकारिक Arduino लाइब्रेरी खोजें और इंस्टॉल करें।",
    "gui.libraryManager.searchPlaceholder": "Arduino लाइब्रेरी खोजें (उदाहरण: Servo)",
    "gui.libraryManager.search": "खोजें",
    "gui.libraryManager.searching": "खोज रहे हैं...",
    "gui.libraryManager.advancedOptionsShow": "▶ उन्नत विकल्प (कस्टम इंस्टॉल पाथ)",
    "gui.libraryManager.advancedOptionsHide": "▼ उन्नत विकल्प छिपाएं",
    "gui.libraryManager.recommended": "अनुशंसित",
    "gui.libraryManager.installed": "इंस्टॉल किए गए ({count})",
    "gui.libraryManager.searchResults": "खोज परिणाम {count}",
    "gui.libraryManager.refresh": "↻ रीफ्रेश",
    "gui.libraryManager.refreshing": "↻ रीफ्रेश हो रहा है...",
    "gui.gui.librariesBoardsTab": "लाइब्रेरीज़",
    "gui.gui.boardsManagerTab": "बोर्ड मैनेजर",
};

export default hi;
